export default {
  namespaced: true,
  state: { token: localStorage.getItem("token") },
  getters: { isAuthenticated: state => !!state.token }
};
